<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="onSubmit")
    modal(active, title="Trocar analista", @close="$router.back()")
      div(slot="modal-body")
        form-group(:label="'ordem_servico_analise.parecer' | tModel" :validation="$v.form.parecer")
          textarea.form-input(rows="2" placeholder="Informe aqui o seu parecer" v-model.trim="$v.form.parecer.$model" v-autofocus)
        form-group(:label="'ordem_servico_analise.analista' | tModel" :validation="$v.form.analista_id")
          fiscal-picker(v-model="$v.form.analista_id.$model")
      div(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid" :class="{loading}")
          btn-content(icon="fa fa-user-secret" label="Trocar analista")
  </template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "analises/analises": {
      getters: ["loading"],
      state: ["current"],
      actions: ["fetchUpdate"],
    },
  },
  data() {
    return {
      form: {
        parecer: "",
        analista_id: null,
      },
    }
  },
  methods: {
    async onSubmit() {
      try {
        const data = { id: this.current.id, ...this.form }
        await this.fetchUpdate(data)
        this.$toaster.success("Analista alterado")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations: {
    form: {
      parecer: { minLength: minLength(10), required },
      analista_id: { required },
    },
  },
}
</script>
